import React from 'react';
import { SvgIcon } from '@mui/material';

const Close = ({ ...props }) => (
    <SvgIcon {...props} width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
        <g id="Style-Guide" stroke="none" strokeWidth="1" fill="inherit" fillRule="evenodd">
            <g transform="translate(-336.000000, -2276.000000)" id="Icons">
                <g transform="translate(48.000000, 2212.000000)">
                    <g id="Close-Icon" transform="translate(288.000000, 64.000000)">
                        <g id="1.-Icon/Cross/Small">
                            <path
                                d="M18.3721441,15.9994354 L23.5012575,10.8917669 C23.8333747,10.5608921 24,10.1272541 24,9.69361612 C24,9.25997812 23.8333747,8.82634012 23.5012575,8.49546529 C22.8370231,7.8348449 21.7613262,7.8348449 21.0970918,8.49546529 L15.9997166,13.5737728 L10.9023414,8.49546529 C10.238107,7.8348449 9.16241012,7.8348449 8.49817576,8.49546529 C7.83394141,9.15721495 7.83394141,10.2300173 8.49817576,10.8917669 L13.6261556,15.9994354 L8.49817576,21.1082331 C7.83394141,21.7699827 7.83394141,22.8427851 8.49817576,23.5045347 C9.16241012,24.1651551 10.238107,24.1651551 10.9023414,23.5045347 L15.9997166,18.4262272 L21.0970918,23.5045347 C21.7613262,24.1651551 22.8370231,24.1651551 23.5012575,23.5045347 C23.8333747,23.1736599 24,22.7400219 24,22.3063839 C24,21.8727459 23.8333747,21.4391079 23.5012575,21.1082331 L18.3721441,15.9994354 Z"
                                id="Fill-1"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);
export default Close;
